import React from 'react'
import Prism from 'prismjs';
import { IconButton,Typography, Icon} from '@material-ui/core';
import {FileCopy} from '@material-ui/icons'
import { typography } from '@material-ui/system';
export default class CodeBase extends React.Component{
    constructor(props){
        super(props)
        this.state={
            copied:false
        }
        this.inputbox=React.createRef();
    }
    renderCode=()=>{
        let consoleStyle=(window.screen.width<=768)?'consoleStyleMobile':'consoleStyle'
        let lines=this.props.lines
        let language=this.props.lang
        let width='80%'
        if(window.screen.width<=768){
            width=window.screen.width-40;
        }
        let copyButton=null;
        // if(this.state.copied){
        //     copyButton=<span className='textCopiedMessage'>Copied to clip-board</span>
        // }else{
        //     copyButton=<span style={{cursor:'pointer'}} className='textCopiedMessage' onClick={this.copyToClipBoard}>Copy</span>
        // }

        return <>
                <div >
                        <pre className={consoleStyle}   style={{width:width}}>
                            {lines.map((line,index)=>{
                                return this.renderHtmlCode(line,language)
                            })}
{/* 
                        <div style={{display: 'flex',justifyContent: 'space-between',padding: '5px'}} >
                            {copyButton}
                        </div>  */}
                            
                        </pre>
                </div>
            </>
    }
    renderHtmlCode=(code,lang='html')=>{
        let html = Prism.highlight(code, Prism.languages[lang],lang);
        return <code key={Math.random()}  ref={this.inputbox}  dangerouslySetInnerHTML={{__html: html}}></code> 
    }
    //this is to copy content to clipboard
    copyToClipBoard=()=>{
        var range = document.createRange();
        range.selectNode(this.inputbox.current);
        window.getSelection().removeAllRanges(); // clear current selection
        window.getSelection().addRange(range); // to select text
        document.execCommand("copy");
        window.getSelection().removeAllRanges();// to deselect
        this.setState({
            copied:true
        })
        setTimeout(()=>{
            this.setState({copied:false})
        },1200)
    }
    render(){
        let code=this.renderCode();
        return code;
    }
}